import _extends from 'babel-runtime/helpers/extends';

import { devices } from '@/views/creative/utils/device-info';
import JSONParse from '@/utils/JSONParse';
import ptTracker from '@pt/metrics-tracking/playturbo-collector';

export default {
  props: {
    orientation: {
      type: Number,
      default: 1 // 1代表竖屏，2代表横屏
    },
    deviceType: {
      type: Number,
      default: 3 // 1代表 iphonex 2代表ipad 3代表iphone6 4代表红米 5代表vivo
    },
    dynamicZoom: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      scale: 1,
      volumeControllerPosition: {}
    };
  },

  computed: {
    // 根据传参type获取对应显示设备的尺寸
    deviceInfo: function deviceInfo() {
      var _this = this;

      return devices.find(function (item) {
        return item.value === _this.deviceType;
      }) || devices[0];
    },

    // 横竖屏的iframe宽高读取值不一样
    iframeWidth: function iframeWidth() {
      return this.orientation === 1 ? this.deviceInfo.frameWidth : this.deviceInfo.frameHeight;
    },
    iframeHeight: function iframeHeight() {
      return this.orientation === 1 ? this.deviceInfo.frameHeight : this.deviceInfo.frameWidth;
    },

    // 判断 url 里面是否包含 track_data 信息
    trackData: function trackData() {
      var temp = new URL(this.src);
      return JSONParse(temp.searchParams.get('track_data'));
    }
  },
  watch: {
    deviceInfo: function deviceInfo() {
      this.volumeControllerPosition.scale = this.scale;
    }
  },
  methods: {
    getDeviceInfo: function getDeviceInfo() {
      var defaultPosition = {
        scale: 0.84
        // eslint-disable-next-line no-undefined
      };return this.volumeControllerPosition.marginTop !== undefined ? this.volumeControllerPosition : defaultPosition;
    },
    fillZoom: function fillZoom() {
      // 1440尺寸0.8缩放，1920下1缩放
      var scale = 0.8 + 0.2 / (1920 - 1440) * (window.innerWidth - 1440);
      if (scale < 0.8) {
        scale = 0.8;
      } else if (scale > 1.2) {
        scale = 1.2;
      }
      if (!this.dynamicZoom) scale = 1;
      this.scale = scale;
    },
    reload: function reload() {
      // this.$refs.iframe.contentWindow.location.reload(true)
    },
    dispatchEvent: function dispatchEvent(e) {
      if (e && e.data && e.data.type === 'PLAYABLE:gameStart') {
        if (this.trackData) {
          ptTracker.stopEventById(_extends({}, this.trackData, {
            e: 'preview',
            scene: 'pt'
          }), this.trackData.pid);
        }
      }
    }
  },
  mounted: function mounted() {
    this.fillZoom();
    window.addEventListener('message', this.dispatchEvent);
    window.addEventListener('resize', this.fillZoom, false);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('message', this.dispatchEvent);
    window.removeEventListener('resize', this.fillZoom, false);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.fillZoom, false);
  }
};